import React, { useEffect, useState } from 'react';
import PortsAutoComplete from '../../common/PortsAutoComplete';

const HireCargoRegion = ({ cargoRegion, changeFieldsMultiple, countIndex }) => {
    const [region, setRegion] = useState(cargoRegion);

    useEffect(() => {
        setRegion(cargoRegion);
    }, [cargoRegion]);

    const selectPort = (value) => {
        changeFieldsMultiple([
            {
                index: countIndex,
                field: 'cargoRegionId',
                value,
            },
        ]);
    };
    
    return (
        <PortsAutoComplete 
            name={`cargoRegion_${countIndex}`}
            customValue={region ? region.name : ''}
            selectValue={selectPort}
            floatingLabelText='Cargo region'
            withAreas
            mainRegions
            onlyAreas={false}
            floatingLabelStyle={{ display: 'none' }}
            hintText={null}
            underlineStyle={{ display: 'none' }}
            inputStyle={{ fontSize: '10px', marginTop: 'unset' }}
            style={{ top: 'unset' }}
            menuStyle={{ width: '300px' }}
            popoverProps={{
                style: { width: '300px' },
            }}
        />
    );
};

export default React.memo(HireCargoRegion);



// WEBPACK FOOTER //
// ./app/components/Hires/rowData/HireCargoRegion.jsx